<template>
    <div>         
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <boton-atras :nombre_ruta="'informacion'"></boton-atras>

             <div>
                <div>
                    <h6 class="subtitulo mb-2">FOPROVEP.- Exclusión de Coberturas</h6>
                    <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                </div>
                <ul class="parrafo-contenido">
                   <li>Cuando el responsable del resguardo del vehículo no hubiese otorgado su consentimiento expreso o tácito para utilizar la unidad y el conductor del mismo, provoque los daños materiales al vehículo, lesiones o la muerte a terceros.</li>
                   <li>Cuando el vehículo se utilice en actividades ajenas a las funciones que realiza.</li>
                   <li>Cuando el siniestro ocurra en días y horas inhábiles.</li>
                   <li>Cuando se realice el cambio del conductor del vehículo oficial que provocó el siniestro y éste sea identificado por el ajustador o la coordinación.</li>
                   <li>Cuando el siniestro se derive de fallas mecánicas.</li> 
                   <li>Cuando la licencia de conducir esté vencida.</li>
                   <li>Los servidores públicos que tengan prestaciones de seguridad social a través de instituciones médicas, no se cubrirán sus gastos médicos.</li>
                   <li>Conducir bajo el influjo de drogas, enervantes, en estado de ebriedad o aliento alcohólico.</li>
                   <li>Cuando en un término de 60 días a partir de ocurrido el siniestro no se ha puesto a disposición del fideicomiso la unidad siniestrada.</li>
                   <li>Los vehículos que se encuentren fuera del estado así como aquellos que tengan aditamentos especiales, deberán asegurarse a través de aseguradoras particulares.</li>
                   <li>No cumplir en tiempo y forma con la documentación requerida en la normatividad.</li>
                   <li>Cuando exista un tercero responsable.</li>
                   <li>Robos parciales.</li>
                   <li>Cuando el vehículo no este asegurado ante el fideicomiso.</li>
                   <li>Así mismo, no se cubrirá ningún tipo de multa.</li>
                   <li>En carreteras de cuotas, la aseguradora de autopista se hará cargo de los daños ocasionados.</li>
                </ul>            
            </div>
             
            
         </div>
    </div>
</template>
<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // variables
        }
    },
    components:{
        botonAtras
    }
}
</script>

<style scoped>

@media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; text-align: justify; }

    
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
}

</style>